var routes = window.Laravel.routes;
module.exports = function() {
  var args = Array.prototype.slice.call(arguments);
  var name = args.shift();
  var query = [];
  args.filter(arg => typeof arg === 'object').forEach(q => {
    Object.keys(q).forEach(key => {
      query.push({
        key: key,
        value: q[key]
      });
    });
  });
  if (routes[name] === undefined) {
    console.error('Route not found ', name);
  } else {
    return (
      window.Laravel.baseUrl +
      '/' +
      routes[name]
        .split('/')
        .map((s) => (s[0] == '{' ? args.shift() : s))
        .join('/') +
        query.map((q, index) => index === 0 ? `?${q.key}=${q.value}`: `${q.key}=${q.value}`).join('&')
    );
  }
};
